<template>
    <div
        class="support-categories"
        data-aos="fade-up"
        data-aos-once="true"
        data-aos-delay="0"
    >
        <div class="support-categories__cards-container">
            <div
                v-if="this.categoryStack.length > 0"
                class="support-categories__back-button-container"
            >
                <span
                    class="icon-chevron-left support-categories__back-icon"
                ></span>
                <div @click="goBack()" class="support-categories__back-button">
                    {{ translations?.GoBack }}
                </div>
            </div>
            <TransitionGroup
                name="cards"
                tag="div"
                class="support-categories__cards-wrapper"
            >
                <div
                    v-for="category in currentCategory"
                    :key="category.Id"
                    class="support-categories-card"
                >
                    <SupportCategoriesCard
                        :displayTitle="category.DisplayTitle"
                        :imageUrl="category.CategoryCoverImageUrl"
                        :imageAlt="category.CategoryCoverImage"
                        :childCategories="category.ChildCategories"
                        :onEnterCategory="enterCategory"
                        :currentCategory="currentCategory"
                        :urlName="category.UrlName"
                    ></SupportCategoriesCard>
                </div>
            </TransitionGroup>
        </div>
        <div class="support-categories__lookup-container">
            <div class="support-categories__lookup-divider"></div>
            <div class="support-categories__search-wrap">
                <div class="support-categories__label">
                    {{ translations?.IfYouKnowYourProductNumber }}
                </div>
                <div class="support-categories__search">
                    <div class="support-categories__lookup-form-container">
                        <input
                            id="js-input-model-num"
                            ref="searchInput"
                            :placeholder="translations?.ModelNumber"
                            class="support-categories__lookup-form"
                            @keyup="checkValue"
                            v-bind:class="
                                supportCategoryError ? 'is-invalid' : ''
                            "
                        />
                        <button
                            @click="runLookup"
                            class="support-categories__lookup-button"
                        >
                            <span class="icon-chevron-right"></span>
                        </button>
                    </div>
                    <div
                        v-if="supportCategoryError"
                        class="support-categories__error"
                    >
                        Please enter a search term
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {
    ISupportCategory,
    ISupportCategoryTopLevel,
} from 'Vue/interfaces/Interfaces';
import SupportCategoriesCard from 'Vue/components/supportCategories/SupportCategoriesCard.vue';
import { ISupportCategoriesAppTranslations } from 'Vue/interfaces/Interfaces';

export default {
    name: 'SupportCategories',
    components: {
        SupportCategoriesCard,
    },
    data() {
        return {
            supportCategories: [] as ISupportCategory[],
            currentCategory: [] as ISupportCategory[],
            categoryStack: [],
            supportCategoryError: false,
            translations: {} as ISupportCategoriesAppTranslations,
        };
    },
    methods: {
        async getSupportCategoriesData() {
            let categoryDiv = document.getElementById('productCategoriesData');
            let categoriesData: ISupportCategoryTopLevel = JSON.parse(
                categoryDiv.getAttribute('data-page-data')
            );
            this.supportCategories = categoriesData.SupportCategories;
            this.currentCategory = categoriesData.SupportCategories;
        },

        setCurrentCategory(childCategories) {
            this.currentCategory = childCategories;
        },

        enterCategory(currentCategory, childCategories) {
            this.categoryStack.push(currentCategory);
            this.setCurrentCategory(childCategories);
        },

        checkValue() {
            let input = this.$refs.searchInput;
            let inputValue = input.value;

            if (inputValue.length) {
                this.supportCategoryError = false;
            }
        },

        goBack() {
            this.setCurrentCategory(this.categoryStack.pop());
        },

        runLookup() {
            let input = this.$refs.searchInput;
            let inputValue = input.value;

            if (inputValue.length) {
                window.location.href = `/search?FilterCriteria.Query=${inputValue}&FilterCriteria.Tab=products`;
            } else {
                this.supportCategoryError = true;
            }
        },

        getTranslations() {
            let supportCategoryDiv = document.getElementById(
                'productCategoriesData'
            );
            return JSON.parse(
                supportCategoryDiv.getAttribute('data-translations')
            );
        },
    },
    created() {
        this.getSupportCategoriesData();
        this.translations = this.getTranslations();
    },
    mounted() {
        // console.log(this.supportCategories);
    },
};
</script>
